Quiz.questwin =  {

	props: ['value'],

	data : function() {
		return {
			"visible": false,
			"bg": "",
			"glyph": "",
			"state": 'summary',
			"title": "",
			"rules": "",
			"ranks": [],
			"id": "",
			"reg_text": "",
			"reg_link": "",
			"has_reg": false,

			"info": {},

			"question": "",
			"qphoto": "",
			"qphotoformat": "",
			"qcurrent": 0,
			"qtotal": 0,
			"answers": [],
			"shownextbutton": false,
			"correct": 0,
			"answered": 0,

			"winmsg": "",
			"winicon": "",
			"cansave": false,
			"totalTime": "",
			"rank": {},
			"result": "",

			"nickname": "",
			"nicknameerror": false,
			"time": "",
			"hasTitle": false,
			"big": ""
		};		
	},

	mounted: function() {
	},

	methods: {
		open: function(id, glyph, opener, first) {
			var self = this;
			this.state = "question";
			this.opener = opener;
			this.shownextbutton = false;
			this.glyph = glyph;
			this.id = id;
			this.hasTitle = false;			

			ssi("quiz","anyQuestion",{"id": this.id, "first": first != undefined ? first : ""}, function(resp) {

				self.gqid = resp.data.gqid;
				self.question = resp.data.question;
				self.qcurrent = resp.data.question_number;
				self.qtotal = resp.data.total_questions;

				self.answers = [];

				if (resp.data.answer1 != "") self.answers.push({"text": resp.data.answer1, "s": "A"});
				if (resp.data.answer2 != "") self.answers.push({"text": resp.data.answer2, "s": "B"});
				if (resp.data.answer3 != "") self.answers.push({"text": resp.data.answer3, "s": "C"});
				if (resp.data.answer4 != "") self.answers.push({"text": resp.data.answer4, "s": "D"});
				if (resp.data.answer5 != "") self.answers.push({"text": resp.data.answer5, "s": "E"});

				if (resp.data.photo != "" && resp.data.photo != null) {
					self.qphoto = "/storage/quiz/" + resp.data.photo;
					var len = resp.data.photo.length;
					$("#quiz-video").html("");

					if (resp.data.photo.substring(len - 3) == 'mp4') {
						self.qphotoformat = "mp4";
						this.media = new vplayer();
						//this.media.fitScreen(200, 150);
						this.media.style("", {"backgroundColor": "#ffffff"});
						this.media.load(self.qphoto);
						this.media.setLoop(true);
						this.media.showControls(false);
						setTimeout(function() {
							$("#quiz-video").append(this.media.embed());
							this.media.playButton(null);
							self.visible = true;
						}.bind(this), 150);
					}
					else {
						self.qphotoformat = "image";
						self.visible = true;
					}
				} else {
					self.qphoto = "";
					self.visible = true;
				}

			});

		},


		answer: function(idx) {
			var self = this;

			ssi("quiz","checkAnswer", {"id":this.id, "question": self.gqid, "answer": idx}, function(resp) {
				self.correct = resp.data.correct == "true" ? true : false;
				self.answered = idx;

				self.shownextbutton = true;

				setTimeout(function() {
					this.close();
					this.opener(self.correct);
				}.bind(this), 300);

			}.bind(this));
		},

		
		close: function() {
			this.visible = false;
		}
	},

	watch: {
	},

	template: '#tpl-questwin'
	
};